import { request } from './client';
import type { StockCountApproveResult, StockCountCard, StockCountCreate, StockCountRef } from '@kassa/shared';

// Sayım (KT-108 (6b)). Oxunuşlar internetsiz növbə ilə gedir (offlineQueue, path /api/counts/:id/scans).
export const countsApi = {
  counts: () => request<StockCountRef[]>('GET', '/api/counts'),
  countCreate: (body: StockCountCreate) => request<StockCountRef>('POST', '/api/counts', body),
  countCard: (id: string) => request<StockCountCard>('GET', `/api/counts/${encodeURIComponent(id)}`),
  countSubmit: (id: string) => request<StockCountCard>('POST', `/api/counts/${encodeURIComponent(id)}/submit`),
  countReopen: (id: string) => request<StockCountRef>('POST', `/api/counts/${encodeURIComponent(id)}/reopen`),
  countCancel: (id: string) => request<StockCountRef>('POST', `/api/counts/${encodeURIComponent(id)}/cancel`),
  countApprove: (id: string) => request<StockCountApproveResult>('POST', `/api/counts/${encodeURIComponent(id)}/approve`),
  /** Növbə elementinin göndərilməsi (path serverin verdiyi forma ilə yoxlanır) */
  queuePost: (path: string, body: unknown) => request<unknown>('POST', path, body),
};
